import {defineChain} from 'viem'

export const shimmerEvm = defineChain({
  id: JSON.parse(import.meta.env.VITE_SHIMMER_CHAIN_ID),
  name: import.meta.env.VITE_SHIMMER_CHAIN_NAME,
  network: import.meta.env.VITE_SHIMMER_CHAIN_SLUG,
  nativeCurrency: {
    decimals: 6,
    name: import.meta.env.VITE_SHIMMER_CHAIN_CURRENCY_NAME,
    symbol: import.meta.env.VITE_SHIMMER_CHAIN_CURRENCY_SYMBOL,
  },
  rpcUrls: {
    default: {
      http: [import.meta.env.VITE_SHIMMER_USER_RPC],
    },
    public: {
      http: [import.meta.env.VITE_SHIMMER_USER_RPC],
    },
  },
  blockExplorers: {
    default: {name: 'Explorer', url: import.meta.env.VITE_SHIMMER_BLOCK_EXPLORER_URL},
  },
  contracts: {
    // multicall3: {
    //   address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    //   blockCreated: 5882,
    // },
  },
})
